// import Slider from 'react-slick';
// import 'slick-carousel/slick/slick.css';
// import 'slick-carousel/slick/slick-theme.css';
// import React, { useState, useEffect } from 'react';
// import axios from "./axios";
// // import LazyImg from "../src/img/lazy_images.png"
// import backgroundImage from '../src/img/banner-bg-2.jpg'

// const Banner = (props) => {
//     const BannerImages = props.BannerImages;

//     const settings = {
//         dots: true,
//         infinite: true,
//         speed: 1000,
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         autoplay: true,
//         autoplaySpeed: 3000,
//         lazyLoad: 'ondemand'
//     };

//     const handleItemClick = (url) => {
//         // console.log(`Item ${index + 1} clicked`);
//         window.open(url, '_blank')
//     };
//     // console.log(BannerImages);
//     return (
        
// <section>
//     <div className='container'>

//         <>
//             {
//                 BannerImages && BannerImages.length > 0 ? (
//                     BannerImages.length === 1 ? (
                    
//                     <div className='d-flex'>
//                         <img
//                         src={BannerImages[0].img}
//                         alt="slide 1"
//                         onClick={() => handleItemClick(BannerImages[0].url)}
//                         className='ytcr-banner-img'
//                         style={{borderRadius: "15px", width: "1665px"}}
//                         />
//                     </div>

//                     ) : (
//                     <Slider {...settings}>
//                         {BannerImages.map((item, index) => (
//                         <div key={index} className='d-flex'>
//                             <img
//                             src={item.img}
//                             alt={`slide ${index + 1}`}
//                             onClick={() => handleItemClick(item.url)}
//                             className='ytcr-banner-img'
//                             />
//                         </div>
//                         ))}
//                     </Slider>
//                     )
//                 ) : ( null
//                     // <div className='d-flex'>
//                     // <img
//                     //     src={backgroundImage}
//                     //     alt=""
//                     //     className='ytcr-banner-img'
//                     // />
//                     // </div>
//                 )
//             }
//         </>
//         </div>
//         </section>
//     );
// }

// export default Banner;

//----------------------------------

import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import React from 'react';

const Banner = (props) => {
    const BannerImages = props.BannerImages;

    const settings = {
        dots: true,
        infinite: true,
        speed: 800,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: false,
        centerMode: true,
        pauseOnHover: true,
        centerPadding: "350px", // adjust if needed
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    centerPadding: "80px"
                }
            },
            {
                breakpoint: 768,
                settings: {
                    centerMode: false,
                    centerPadding: "0px",
                    slidesToShow: 1
                }
            }
        ]
    };

    const handleItemClick = (url) => {
        if (url) {
            window.open(url, '_blank');
        }
    };

    return (
        <section className="banner-section">
            <div className="container">

                {BannerImages && BannerImages.length > 0 ? (

                    BannerImages.length === 1 ? (
                        <div className='single-banner'>
                            <img
                                src={BannerImages[0].img}
                                alt="banner"
                                onClick={() => handleItemClick(BannerImages[0].url)}
                                className='ytcr-banner-img'
                            />
                        </div>
                    ) : (

                        <Slider {...settings}>
                            {BannerImages.map((item, index) => (
                                <div key={index} className="banner-slide">
                                    <img
                                        src={item.img}
                                        alt={`slide ${index + 1}`}
                                        onClick={() => handleItemClick(item.url)}
                                        className='ytcr-banner-img'
                                    />
                                </div>
                            ))}
                        </Slider>

                    )

                ) : null}

            </div>
        </section>
    );
};

export default Banner;